import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { TableDownstreamWorkbooksQueryVariables, TableDownstreamWorkbooksQuery, WorkbooksDisplayGridRowDataFragment, TableDownstreamWorkbooksFilteredByColumnQueryVariables, TableDownstreamWorkbooksFilteredByColumnQuery, WorkbookSortOrder , TableDownstreamWorkbooksFilteredByColumnDocument , TableDownstreamWorkbooksDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import {
  getRowDataForWorkbook,
  WorkbooksDisplayGrid,
  WorkbooksDisplayGridRowData
} from '../sharedDisplayGrid/WorkbooksDisplayGrid';
import { WorkbooksValidSortFields } from '../sorting/sortProviders/WorkbooksGridSortProvider';

type QueryVariables = TableDownstreamWorkbooksQueryVariables;
type QueryResults = TableDownstreamWorkbooksQuery;
type QueryResultListNode = WorkbooksDisplayGridRowDataFragment;
type GridRowData = WorkbooksDisplayGridRowData;

type QueryVariablesWithFilter = TableDownstreamWorkbooksFilteredByColumnQueryVariables;
type QueryResultsWithFilter = TableDownstreamWorkbooksFilteredByColumnQuery;
type QueryResultListNodeWithFilter = WorkbooksDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].downstreamWorkbooksConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  return resultData && resultData.tables && resultData.tables[0] && resultData.tables[0].columns &&
    resultData.tables[0].columns[0].downstreamWorkbooksConnection;
}


export type TableDownstreamWorkbooksQueryGridProps =
  GridSortProps<WorkbooksValidSortFields> & {
    readonly tableId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function TableDownstreamWorkbooksQueryGrid(props: TableDownstreamWorkbooksQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamWorkbooksLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredWorkbooksLineageGridMessage();

  return (
    props.filteredColumnId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
        queryGql={TableDownstreamWorkbooksFilteredByColumnDocument}
        partialQueryVariables={{ tableId: props.tableId, columnId: props.filteredColumnId, orderBy: props.orderBy as WorkbookSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForWorkbook}
      >
        {({ rowStore }) => <WorkbooksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={TableDownstreamWorkbooksDocument}
        partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as WorkbookSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForWorkbook}
      >
        {({ rowStore }) => <WorkbooksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
